import { FormFieldHeaderColumn } from '../../common/register/form-field-header/form-field-header-column';

export class LabelFormFieldHeaderColumn extends FormFieldHeaderColumn {
  constructor(item) {
    super(item);
    const { content, description } = item;
    this.title = [content, description].filter(Boolean).join(' - ');
  }
}
